import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const InsuranceMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => {
    // Allow digits and one decimal point
    if (/^\d*\.?\d*$/.test(value)) {
      return value;
    }
    return "";
  };
  const [EffectiveFrom, setEffectiveFrom] = useState("");
  const [EffectiveTo, setEffectiveTo] = useState("");
  const [ODDiscountAmount, setODDiscountAmount] = useState("");
  const [ZDpercentage, setZDpercentage] = useState("0");
  const [EPPercentage, setEPPercentage] = useState("0");
  const [CMPercentage, setCMPercentage] = useState("0");
  const [RtiPercentage, setRtiPercentage] = useState("0");
  const [KPPercentage, setKPPercentage] = useState("0");
  const [PBPercentage, setPBPercentage] = useState("0");
  const [GeogAreaExte, setGeogAreaExte] = useState("0");
  const [NonElectAccessPer, setNonElectAccessPer] = useState("0");
  const [ElectAccessper, setElectAccessper] = useState("0");
  const [BiFuelKitCNG, setBiFuelKitCNG] = useState("0");
  const [LossOfIncome, setLossOfIncome] = useState("0");
  const [EmergTransHotelExp, setEmergTransHotelExp] = useState("0");
  const [NCB, setNCB] = useState("0");
  const [Insurance, setInsurance] = useState("0");
  const [IDV, setIDV] = useState("0");
  const [RoadSideAssistance, setRoadSideAssistance] = useState("0");
  const [ThirdPartyLiability, setThirdPartyLiability] = useState("0");
  const [ThirdPartyForBiFuelKit, setThirdPartyForBiFuelKit] = useState("0");
  const [ThirdPartyGeographicalEX, setThirdPartyGeographicalEX] = useState("0");
  const [PACover, setPACover] = useState("0");
  const [PACoverUnnamedPassenper, setPACoverUnnamedPassenper] = useState("0");
  const [PaidDriver, setPaidDriver] = useState("0");
  const [LegalLiabilityPaidDriver, setLegalLiabilityPaidDriver] = useState("0");
  const [ThirdPartyForOneYear, setThirdPartyForOneYear] = useState("0");
  const [ThirdPartyForTwoYear, setThirdPartyForTwoYear] = useState("0");
  const [ThirdPartyForThreeYear, setThirdPartyForThreeYear] = useState("0");
  const [ODpercentagefor1Year, setODpercentagefor1Year] = useState("0");
  const [ODpercentagefor2Year, setODpercentagefor2Year] = useState("0");
  const [ODpercentagefor3Year, setODpercentagefor3Year] = useState("0");
  const [BatteryProtection, setBatteryProtection] = useState("0");
  const [ChargerProtection, setChargerProtection] = useState("0");
  const [DailyAllowance, setDailyAllowance] = useState("0");
  const [Consumables, setConsumables] = useState("0");
  const [NilDepreciation, setNilDepreciation] = useState("0");
  const [BatteyCover, setBatteyCover] = useState("0");
  const [EmiCover, setEmiCover] = useState("0");
  const [TyreAndAllowCover, setTyreAndAllowCover] = useState("0");
  const [Towing, setTowing] = useState("0");
  const [ZDChecked, setZDChecked] = useState(false);
  const [EPChecked, setEPChecked] = useState(false);
  const [CMChecked, setCMChecked] = useState(false);
  const [RTIChecked, setRTIChecked] = useState(false);
  const [KPChecked, setKPChecked] = useState(false);
  const [PBChecked, setPBChecked] = useState(false);
  const [errors, setErrors] = useState({});
  const [InsuranceCompanyList, setInsuranceCompanyList] = useState([]);
  const [InsuranceCompany, setInsuranceCompany] = useState("");
  const [FuelList, setFuelList] = useState([]);
  const [Fuel, setFuel] = useState("");
  const [loading, setLoading] = useState(false);
  const [CubricCapacity, setCubricCapacity] = useState("");
  const [RegistrationZone, setRegistrationZone] = useState("");
  const [ModalType, setModalType] = useState("");
  const [GSTPercentageList, setGSTPercentageList] = useState([]);
  const [GSTPercentage, setGSTPercentage] = useState("");
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [imageUpload, setImageUpload] = useState(null);
  const [insuranceDocumentpdf, setInsuranceDocumentpdf] = useState(null);
  const [filePath1, setFilePath1] = useState("");
  const [filePath2, setFilePath2] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [editId, setEditId] = useState("");
  const [ViewId, setViewId] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);

  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const cubricOptions = [
    { value: "0-1000", label: "0-1000" },
    { value: "1000-1500", label: "1000-1500" },
    { value: "above 1500", label: "above 1500" },
  ];
  const zoneOptions = [
    { value: "Zone A", label: "Zone A" },
    { value: "Zone B", label: "Zone B" },
  ];
  const modalOptions = [
    { value: "Premium", label: "Premium" },
    { value: "Other", label: "Other" },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const handleExit = () => {
    navigate("/Insurancemaster/grid");
  };

  useEffect(() => {
    fetchInsuranceCompany();
    fetchFuelList();
    fetchGSTList();
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  const fetchInsuranceCompany = async () => {
    try {
      const response = await apiFetch(
        "/api/insurance-master/list",
      );
      const data = await response.json();
      const list = data.map((item) => ({
        label: item.value,
        value: item.data,
      }));
      setInsuranceCompanyList(list);
    } catch (error) {
      console.error("Error fetching insurance company:", error);
    }
  };

  const fetchFuelList = async () => {
    try {
      const response = await apiFetch(
        "/api/fuel/list",
      );
      const data = await response.json();
      setFuelList(data);
    } catch (error) {
      console.error("Error fetching fuel list:", error);
    }
  };

  const fetchGSTList = async () => {
    try {
      const response = await apiFetch(
        "/api/gst/list",
      );
      const data = await response.json();
      setGSTPercentageList(data);
    } catch (error) {
      console.error("Error fetching GST:", error);
    }
  };

  const uploadFile = async (file) => {
    if (!file) {
      alert("Please select a file first");
      return "";
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await apiFetch(
      "/api/insurance-master/upload-file",
      { method: "POST", body: formData },
    );
    const data = await res.json();
    return data.filePath;
  };
  const toNumberOrNull = (val) => {
    if (val === "" || val === undefined || val === null) {
      return null; // prevents PostgreSQL integer error
    }
    return Number(val);
  };
  const handleSave = async () => {
    try {
      if (!InsuranceCompany || !CubricCapacity || !RegistrationZone) {
        alert("Please fill all required fields.");
        return;
      }
      const now = new Date();
      const modifyDate = now.toISOString().split("T")[0];
      const payload = {
        prefix: `INS-${Date.now()}`,
        what: "insert",
        sp_811: null,
        sp_812: null,
        sp_813: userId,
        sp_814: ipAddress,
        sp_815: serverIp,
        sp_816: null,
        sp_817: InsuranceCompany,
        sp_818: CubricCapacity,
        sp_819: RegistrationZone,
        sp_820: ModalType || null,
        sp_821: EffectiveFrom || null,
        sp_822: EffectiveTo || null,
        sp_823: Fuel || null,
        sp_824: toNumberOrNull(IDV),

        sp_81_2: null,
        sp_81_3: toNumberOrNull(ODDiscountAmount),
        sp_81_4: toNumberOrNull(ZDpercentage),
        sp_81_5: 0,
        sp_81_5_1: ZDChecked ? 1 : 0,

        sp_81_6: toNumberOrNull(EPPercentage),
        sp_81_7: 0,
        sp_81_7_1: EPChecked ? 1 : 0,

        sp_81_8: toNumberOrNull(CMPercentage),
        sp_81_9: 0,
        sp_81_9_1: CMChecked ? 1 : 0,
        sp_81_10: toNumberOrNull(RtiPercentage),
        sp_81_11: 0,
        sp_81_11_1: RTIChecked ? 1 : 0,
        sp_81_12: KPPercentage ? Number(KPPercentage) * 100 : null,
        sp_81_13: 0,
        sp_81_13_1: KPChecked ? 1 : 0,
        sp_81_14: PBPercentage ? Number(PBPercentage) * 100 : null,
        sp_81_15: 0,
        sp_81_15_1: PBChecked ? 1 : 0,
        sp_81_16: toNumberOrNull(GeogAreaExte),
        sp_81_17: toNumberOrNull(NonElectAccessPer),
        sp_81_18: toNumberOrNull(ElectAccessper),
        sp_81_19: toNumberOrNull(BiFuelKitCNG),
        sp_81_20: toNumberOrNull(ThirdPartyLiability),
        sp_81_21: toNumberOrNull(ThirdPartyForBiFuelKit),
        sp_81_22: toNumberOrNull(ThirdPartyGeographicalEX),
        sp_81_23: toNumberOrNull(PACover),
        sp_81_24: toNumberOrNull(PACoverUnnamedPassenper),
        sp_81_25: toNumberOrNull(PaidDriver),
        sp_81_26: toNumberOrNull(LegalLiabilityPaidDriver),
        sp_81_27: toNumberOrNull(GSTPercentage),
        sp_81_28: toNumberOrNull(ThirdPartyForOneYear),
        sp_81_29: toNumberOrNull(ThirdPartyForTwoYear),
        sp_81_30: toNumberOrNull(ThirdPartyForThreeYear),

        sp_81_31: toNumberOrNull(ODpercentagefor1Year),
        sp_81_32: toNumberOrNull(ODpercentagefor2Year),
        sp_81_33: toNumberOrNull(ODpercentagefor3Year),

        sp_81_34: filePath1 || null,
        sp_81_35: filePath2 || null,

        sp_81_36: toNumberOrNull(NCB),
        sp_81_37: toNumberOrNull(Insurance),
        sp_81_38: toNumberOrNull(IDV),
        sp_81_39: Fuel || null,

        sp_81_40: toNumberOrNull(BatteryProtection),
        sp_81_41: toNumberOrNull(ChargerProtection),
        sp_81_42: toNumberOrNull(DailyAllowance),
        sp_81_43: toNumberOrNull(Consumables),
        sp_81_44: toNumberOrNull(NilDepreciation),
        sp_81_45: toNumberOrNull(BatteyCover),
        sp_81_46: toNumberOrNull(EmiCover),
        sp_81_47: toNumberOrNull(TyreAndAllowCover),
        sp_81_48: toNumberOrNull(Towing),
        sp_81_49: toNumberOrNull(RoadSideAssistance),
        sp_81_50: toNumberOrNull(LossOfIncome),
        sp_81_51: toNumberOrNull(EmergTransHotelExp),
      };
      setLoading(true);
      const response = await apiFetch(
        "/api/insurance-master/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const resData = await response.json();
      setLoading(false);
      if (resData?.message) {
        alert(resData.message);
      } else {
        alert("Saved successfully.");
      }
      navigate("/Insurancemaster/grid");
    } catch (err) {
      setLoading(false);
      console.error("SAVE ERROR:", err);
      alert(err.message || "Save failed");
    }
  };

  const handleUpdate = async () => {
    try {
      if (!InsuranceCompany || !CubricCapacity || !RegistrationZone) {
        alert("Please fill all required fields.");
        return;
      }

      if (!editId) {
        alert("No record selected to update.");
        return;
      }

      const payload = {
        prefix: `INS-${Date.now()}`,
        what: "update", // ✅ FIXED
        sp_811: null,
        sp_812: editId, // ✅ FIXED
        sp_813: userId,
        sp_814: ipAddress,
        sp_815: serverIp,
        sp_816: null,

        sp_817: InsuranceCompany,
        sp_818: CubricCapacity,
        sp_819: RegistrationZone,
        sp_820: ModalType || null,
        sp_821: EffectiveFrom || null,
        sp_822: EffectiveTo || null,
        sp_823: Fuel || null,
        sp_824: toNumberOrNull(IDV),

        sp_81_2: null,
        sp_81_3: toNumberOrNull(ODDiscountAmount),
        sp_81_4: toNumberOrNull(ZDpercentage),
        sp_81_5: 0,
        sp_81_5_1: ZDChecked ? 1 : 0,

        sp_81_6: toNumberOrNull(EPPercentage),
        sp_81_7: 0,
        sp_81_7_1: EPChecked ? 1 : 0,

        sp_81_8: toNumberOrNull(CMPercentage),
        sp_81_9: 0,
        sp_81_9_1: CMChecked ? 1 : 0,

        sp_81_10: toNumberOrNull(RtiPercentage),
        sp_81_11: 0,
        sp_81_11_1: RTIChecked ? 1 : 0,

        sp_81_12: KPPercentage ? Number(KPPercentage) * 100 : null,
        sp_81_13: 0,
        sp_81_13_1: KPChecked ? 1 : 0,

        sp_81_14: PBPercentage ? Number(PBPercentage) * 100 : null,
        sp_81_15: 0,
        sp_81_15_1: PBChecked ? 1 : 0,

        sp_81_16: toNumberOrNull(GeogAreaExte),
        sp_81_17: toNumberOrNull(NonElectAccessPer),
        sp_81_18: toNumberOrNull(ElectAccessper),
        sp_81_19: toNumberOrNull(BiFuelKitCNG),

        sp_81_20: toNumberOrNull(ThirdPartyLiability),
        sp_81_21: toNumberOrNull(ThirdPartyForBiFuelKit),
        sp_81_22: toNumberOrNull(ThirdPartyGeographicalEX),
        sp_81_23: toNumberOrNull(PACover),
        sp_81_24: toNumberOrNull(PACoverUnnamedPassenper),
        sp_81_25: toNumberOrNull(PaidDriver),
        sp_81_26: toNumberOrNull(LegalLiabilityPaidDriver),

        sp_81_27: toNumberOrNull(GSTPercentage),

        sp_81_28: toNumberOrNull(ThirdPartyForOneYear),
        sp_81_29: toNumberOrNull(ThirdPartyForTwoYear),
        sp_81_30: toNumberOrNull(ThirdPartyForThreeYear),

        sp_81_31: toNumberOrNull(ODpercentagefor1Year),
        sp_81_32: toNumberOrNull(ODpercentagefor2Year),
        sp_81_33: toNumberOrNull(ODpercentagefor3Year),

        sp_81_34: filePath1 || null,
        sp_81_35: filePath2 || null,

        sp_81_36: toNumberOrNull(NCB),
        sp_81_37: toNumberOrNull(Insurance),
        sp_81_38: toNumberOrNull(IDV),
        sp_81_39: Fuel || null,

        sp_81_40: toNumberOrNull(BatteryProtection),
        sp_81_41: toNumberOrNull(ChargerProtection),
        sp_81_42: toNumberOrNull(DailyAllowance),
        sp_81_43: toNumberOrNull(Consumables),
        sp_81_44: toNumberOrNull(NilDepreciation),
        sp_81_45: toNumberOrNull(BatteyCover),
        sp_81_46: toNumberOrNull(EmiCover),
        sp_81_47: toNumberOrNull(TyreAndAllowCover),
        sp_81_48: toNumberOrNull(Towing),
        sp_81_49: toNumberOrNull(RoadSideAssistance),
        sp_81_50: toNumberOrNull(LossOfIncome),
        sp_81_51: toNumberOrNull(EmergTransHotelExp),
      };

      setLoading(true);

      const response = await apiFetch(
        "/api/insurance-master/update",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const resData = await response.json();
      setLoading(false);

      alert(resData?.message || "Updated successfully.");
      navigate("/Insurancemaster/grid");
    } catch (err) {
      setLoading(false);
      console.error("UPDATE ERROR:", err);
      alert(err.message || "Update failed");
    }
  };
  useEffect(() => {
    if (!location.state?.editData) return;
    const editData = location.state?.editData;
    if (!editData) return;
    const parsedHeader = JSON.parse(editData.notices[0]);
    const parsedDetail = JSON.parse(editData.notices[1]);
    const header = parsedHeader[0];
    const detail = parsedDetail[0];
    setIsEditMode(true);
    if (
      InsuranceCompanyList.length === 0 ||
      FuelList.length === 0 ||
      GSTPercentageList.length === 0
    ) {
      return;
    }

    setEditId(header.sp_812 || "");
    const comp = InsuranceCompanyList.find(
      (item) => item.value === header.sp_817,
    );
    setInsuranceCompany(comp ? comp.value : "");
    const fuelMatch = FuelList.find((item) => item.value === header.sp_823);
    setFuel(fuelMatch ? fuelMatch.value : "");

    const gstMatch = GSTPercentageList.find(
      (item) => item.value === detail.sp_81_27,
    );
    setGSTPercentage(gstMatch ? gstMatch.value : "");
    setCubricCapacity(header.sp_818 || "");
    setRegistrationZone(header.sp_819 || "");
    setModalType(header.sp_820 || "");
    setEffectiveFrom(header.sp_821 || "");
    setEffectiveTo(header.sp_822 || "");
    setIDV(header.sp_824 || "");
    setODDiscountAmount(detail.sp_81_3 || "");
    setZDpercentage(detail.sp_81_4 || "");
    setZDChecked(detail.sp_81_5_1 === 1);
    setEPPercentage(detail.sp_81_6 || "");
    setEPChecked(detail.sp_81_7_1 === 1);
    setCMPercentage(detail.sp_81_8 || "");
    setCMChecked(detail.sp_81_9_1 === 1);
    setRtiPercentage(detail.sp_81_10 || "");
    setRTIChecked(detail.sp_81_11_1 === 1);
    setKPPercentage(detail.sp_81_12 ? detail.sp_81_12 / 100 : "");
    setKPChecked(detail.sp_81_13_1 === 1);
    setPBPercentage(detail.sp_81_14 ? detail.sp_81_14 / 100 : "");
    setPBChecked(detail.sp_81_15_1 === 1);
    setGeogAreaExte(detail.sp_81_16 || "");
    setNonElectAccessPer(detail.sp_81_17 || "");
    setElectAccessper(detail.sp_81_18 || "");
    setBiFuelKitCNG(detail.sp_81_19 || "");
    setThirdPartyLiability(detail.sp_81_20 || "");
    setThirdPartyForBiFuelKit(detail.sp_81_21 || "");
    setThirdPartyGeographicalEX(detail.sp_81_22 || "");
    setPACover(detail.sp_81_23 || "");
    setPACoverUnnamedPassenper(detail.sp_81_24 || "");
    setPaidDriver(detail.sp_81_25 || "");
    setLegalLiabilityPaidDriver(detail.sp_81_26 || "");
    setThirdPartyForOneYear(detail.sp_81_28 || "");
    setThirdPartyForTwoYear(detail.sp_81_29 || "");
    setThirdPartyForThreeYear(detail.sp_81_30 || "");
    setODpercentagefor1Year(detail.sp_81_31 || "");
    setODpercentagefor2Year(detail.sp_81_32 || "");
    setODpercentagefor3Year(detail.sp_81_33 || "");
    setFilePath1(detail.sp_81_34 || "");
    setFilePath2(detail.sp_81_35 || "");
    setNCB(detail.sp_81_36 || "");
    setInsurance(detail.sp_81_37 || "");
    setIDV(detail.sp_81_38 || "");
    setBatteryProtection(detail.sp_81_40 || "");
    setChargerProtection(detail.sp_81_41 || "");
    setDailyAllowance(detail.sp_81_42 || "");
    setConsumables(detail.sp_81_43 || "");
    setNilDepreciation(detail.sp_81_44 || "");
    setBatteyCover(detail.sp_81_45 || "");
    setEmiCover(detail.sp_81_46 || "");
    setTyreAndAllowCover(detail.sp_81_47 || "");
    setTowing(detail.sp_81_48 || "");
    setRoadSideAssistance(detail.sp_81_49 || "");
    setLossOfIncome(detail.sp_81_50 || "");
    setEmergTransHotelExp(detail.sp_81_51 || "");
  }, [location.state, InsuranceCompanyList, FuelList, GSTPercentageList]);

  useEffect(() => {
    if (!location.state?.ViewData) return;
    const ViewData = location.state?.ViewData;
    if (!ViewData) return;
    const parsedHeader = JSON.parse(ViewData.notices[0]);
    const parsedDetail = JSON.parse(ViewData.notices[1]);
    const header = parsedHeader[0];
    const detail = parsedDetail[0];
    setIsViewMode(true);
    if (
      InsuranceCompanyList.length === 0 ||
      FuelList.length === 0 ||
      GSTPercentageList.length === 0
    ) {
      return;
    }
    setViewId(header.sp_812 || "");
    const comp = InsuranceCompanyList.find(
      (item) => item.value === header.sp_817,
    );
    setInsuranceCompany(comp ? comp.value : "");
    const fuelMatch = FuelList.find((item) => item.value === header.sp_823);
    setFuel(fuelMatch ? fuelMatch.value : "");

    const gstMatch = GSTPercentageList.find(
      (item) => item.value === detail.sp_81_27,
    );
    setGSTPercentage(gstMatch ? gstMatch.value : "");
    setCubricCapacity(header.sp_818 || "");
    setRegistrationZone(header.sp_819 || "");
    setModalType(header.sp_820 || "");
    setEffectiveFrom(header.sp_821 || "");
    setEffectiveTo(header.sp_822 || "");
    setIDV(header.sp_824 || "");
    setODDiscountAmount(detail.sp_81_3 || "");
    setZDpercentage(detail.sp_81_4 || "");
    setZDChecked(detail.sp_81_5_1 === 1);
    setEPPercentage(detail.sp_81_6 || "");
    setEPChecked(detail.sp_81_7_1 === 1);
    setCMPercentage(detail.sp_81_8 || "");
    setCMChecked(detail.sp_81_9_1 === 1);
    setRtiPercentage(detail.sp_81_10 || "");
    setRTIChecked(detail.sp_81_11_1 === 1);
    setKPPercentage(detail.sp_81_12 || "");
    setKPChecked(detail.sp_81_13_1 === 1);
    setPBPercentage(detail.sp_81_14 || "");
    setPBChecked(detail.sp_81_15_1 === 1);
    setGeogAreaExte(detail.sp_81_16 || "");
    setNonElectAccessPer(detail.sp_81_17 || "");
    setElectAccessper(detail.sp_81_18 || "");
    setBiFuelKitCNG(detail.sp_81_19 || "");
    setThirdPartyLiability(detail.sp_81_20 || "");
    setThirdPartyForBiFuelKit(detail.sp_81_21 || "");
    setThirdPartyGeographicalEX(detail.sp_81_22 || "");
    setPACover(detail.sp_81_23 || "");
    setPACoverUnnamedPassenper(detail.sp_81_24 || "");
    setPaidDriver(detail.sp_81_25 || "");
    setLegalLiabilityPaidDriver(detail.sp_81_26 || "");
    setThirdPartyForOneYear(detail.sp_81_28 || "");
    setThirdPartyForTwoYear(detail.sp_81_29 || "");
    setThirdPartyForThreeYear(detail.sp_81_30 || "");
    setODpercentagefor1Year(detail.sp_81_31 || "");
    setODpercentagefor2Year(detail.sp_81_32 || "");
    setODpercentagefor3Year(detail.sp_81_33 || "");
    setFilePath1(detail.sp_81_34 || "");
    setFilePath2(detail.sp_81_35 || "");
    setNCB(detail.sp_81_36 || "");
    setInsurance(detail.sp_81_37 || "");
    setIDV(detail.sp_81_38 || "");
    setBatteryProtection(detail.sp_81_40 || "");
    setChargerProtection(detail.sp_81_41 || "");
    setDailyAllowance(detail.sp_81_42 || "");
    setConsumables(detail.sp_81_43 || "");
    setNilDepreciation(detail.sp_81_44 || "");
    setBatteyCover(detail.sp_81_45 || "");
    setEmiCover(detail.sp_81_46 || "");
    setTyreAndAllowCover(detail.sp_81_47 || "");
    setTowing(detail.sp_81_48 || "");
    setRoadSideAssistance(detail.sp_81_49 || "");
    setLossOfIncome(detail.sp_81_50 || "");
    setEmergTransHotelExp(detail.sp_81_51 || "");
  }, [location.state, InsuranceCompanyList, FuelList, GSTPercentageList]);

  useEffect(() => {
    if (!location.state?.copyData) return;
    const copyData = location.state.copyData;
    const parsedHeader = JSON.parse(copyData.notices[0]);
    const parsedDetail = JSON.parse(copyData.notices[1]);
    const header = parsedHeader[0];
    const detail = parsedDetail[0];
    setIsEditMode(false);
    setIsViewMode(false);
    setEditId("");
    const comp = InsuranceCompanyList.find(
      (item) => item.value === header.sp_817,
    );
    setInsuranceCompany(comp ? comp.value : "");
    const fuelMatch = FuelList.find((item) => item.value === header.sp_823);
    setFuel(fuelMatch ? fuelMatch.value : "");

    const gstMatch = GSTPercentageList.find(
      (item) => item.value === detail.sp_81_27,
    );
    setGSTPercentage(gstMatch ? gstMatch.value : "");
    setCubricCapacity(header.sp_818 || "");
    setRegistrationZone(header.sp_819 || "");
    setModalType(header.sp_820 || "");
    setEffectiveFrom("");
    setEffectiveTo("");
    setIDV(header.sp_824 || "");
    setODDiscountAmount(detail.sp_81_3 || "");
    setZDpercentage(detail.sp_81_4 || "");
    setZDChecked(detail.sp_81_5_1 === 1);
    setEPPercentage(detail.sp_81_6 || "");
    setEPChecked(detail.sp_81_7_1 === 1);
    setCMPercentage(detail.sp_81_8 || "");
    setCMChecked(detail.sp_81_9_1 === 1);
    setRtiPercentage(detail.sp_81_10 || "");
    setRTIChecked(detail.sp_81_11_1 === 1);
    setKPPercentage(detail.sp_81_12 || "");
    setKPChecked(detail.sp_81_13_1 === 1);
    setPBPercentage(detail.sp_81_14 || "");
    setPBChecked(detail.sp_81_15_1 === 1);
    setGeogAreaExte(detail.sp_81_16 || "");
    setNonElectAccessPer(detail.sp_81_17 || "");
    setElectAccessper(detail.sp_81_18 || "");
    setBiFuelKitCNG(detail.sp_81_19 || "");
    setThirdPartyLiability(detail.sp_81_20 || "");
    setThirdPartyForBiFuelKit(detail.sp_81_21 || "");
    setThirdPartyGeographicalEX(detail.sp_81_22 || "");
    setPACover(detail.sp_81_23 || "");
    setPACoverUnnamedPassenper(detail.sp_81_24 || "");
    setPaidDriver(detail.sp_81_25 || "");
    setLegalLiabilityPaidDriver(detail.sp_81_26 || "");
    setThirdPartyForOneYear(detail.sp_81_28 || "");
    setThirdPartyForTwoYear(detail.sp_81_29 || "");
    setThirdPartyForThreeYear(detail.sp_81_30 || "");
    setODpercentagefor1Year(detail.sp_81_31 || "");
    setODpercentagefor2Year(detail.sp_81_32 || "");
    setODpercentagefor3Year(detail.sp_81_33 || "");
    setFilePath1(detail.sp_81_34 || "");
    setFilePath2(detail.sp_81_35 || "");
    setNCB(detail.sp_81_36 || "");
    setInsurance(detail.sp_81_37 || "");
    setIDV(detail.sp_81_38 || "");
    setBatteryProtection(detail.sp_81_40 || "");
    setChargerProtection(detail.sp_81_41 || "");
    setDailyAllowance(detail.sp_81_42 || "");
    setConsumables(detail.sp_81_43 || "");
    setNilDepreciation(detail.sp_81_44 || "");
    setBatteyCover(detail.sp_81_45 || "");
    setEmiCover(detail.sp_81_46 || "");
    setTyreAndAllowCover(detail.sp_81_47 || "");
    setTowing(detail.sp_81_48 || "");
    setRoadSideAssistance(detail.sp_81_49 || "");
    setLossOfIncome(detail.sp_81_50 || "");
    setEmergTransHotelExp(detail.sp_81_51 || "");
  }, [location.state, InsuranceCompanyList, FuelList, GSTPercentageList]);

  const inputStyle = (error) => ({
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "14px",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  return (
    <Layout>
      <div className="page-container-imd">
        <div className="container-imd">
          <div className="header-imd">Insurance Master</div>

          <div className="form-grid-imd">
            <div className="form-item-imd">
              <label>Insurance Company</label>

              <Select
                classNamePrefix="rs"
                options={InsuranceCompanyList}
                value={
                  InsuranceCompanyList.find(
                    (o) => o.value === InsuranceCompany,
                  ) || null
                }
                onChange={(selected) =>
                  setInsuranceCompany(selected?.value || "")
                }
                styles={customStyles}
                placeholder="Select Insurance Company"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>Effective From:</label>
              <input
                type="date"
                className="input-imd"
                value={EffectiveFrom}
                onChange={(e) => setEffectiveFrom(e.target.value)}
              />
            </div>
            <div className="form-item-imd">
              <label>Effective To:</label>
              <input
                type="date"
                className="input-imd"
                value={EffectiveTo}
                onChange={(e) => setEffectiveTo(e.target.value)}
              />
            </div>
            <div className="form-item-imd">
              <label>Fuel Type</label>
              <Select
                classNamePrefix="rs"
                options={FuelList}
                value={FuelList.find((o) => o.value === Fuel) || null}
                onChange={(selected) => setFuel(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Fuel"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>Cubric Capacity</label>
              <Select
                classNamePrefix="rs"
                options={cubricOptions}
                value={
                  cubricOptions.find((o) => o.value === CubricCapacity) || null
                }
                onChange={(selected) =>
                  setCubricCapacity(selected?.value || "")
                }
                styles={customStyles}
                placeholder="Select Cubric Capacity"
                isSearchable={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-item-imd">
              <label>Registration Zone</label>
              <Select
                classNamePrefix="rs"
                options={zoneOptions}
                value={
                  zoneOptions.find((o) => o.value === RegistrationZone) || null
                }
                onChange={(selected) =>
                  setRegistrationZone(selected?.value || "")
                }
                styles={customStyles}
                placeholder="Select Registration Zone"
                isSearchable={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>Modal Type</label>
              <Select
                classNamePrefix="rs"
                options={modalOptions}
                value={modalOptions.find((o) => o.value === ModalType) || null}
                onChange={(selected) => setModalType(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Modal Type"
                isSearchable={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>OD Discount Amount</label>
              <input
                type="number"
                className="input-imd"
                value={ODDiscountAmount}
                onChange={(e) =>
                  setODDiscountAmount(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>ZD%</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={ZDpercentage}
                  onChange={(e) =>
                    setZDpercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={ZDChecked}
                  onChange={(e) => setZDChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>EP%</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={EPPercentage}
                  onChange={(e) =>
                    setEPPercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={EPChecked}
                  onChange={(e) => setEPChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>CM%</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={CMPercentage}
                  onChange={(e) =>
                    setCMPercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={CMChecked}
                  onChange={(e) => setCMChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>RTI%</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={RtiPercentage}
                  onChange={(e) =>
                    setRtiPercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={RTIChecked}
                  onChange={(e) => setRTIChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>KP(%)</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={KPPercentage}
                  onChange={(e) =>
                    setKPPercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={KPChecked}
                  onChange={(e) => setKPChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>PB(%)</label>
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <input
                  type="number"
                  className="input-imd"
                  value={PBPercentage}
                  onChange={(e) =>
                    setPBPercentage(allowNumbers(e.target.value))
                  }
                  style={{ flex: 1 }}
                />
                <input
                  type="checkbox"
                  checked={PBChecked}
                  onChange={(e) => setPBChecked(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "6px",
                  }}
                />
              </div>
            </div>
            <div className="form-item-imd">
              <label>Geographical Area Extension</label>
              <input
                type="number"
                className="input-imd"
                value={GeogAreaExte}
                onChange={(e) => setGeogAreaExte(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Non Electrical Accessories%</label>
              <input
                type="number"
                className="input-imd"
                value={NonElectAccessPer}
                onChange={(e) =>
                  setNonElectAccessPer(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Electrical Accessories%</label>
              <input
                type="number"
                className="input-imd"
                value={ElectAccessper}
                onChange={(e) =>
                  setElectAccessper(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Bi Fuel Kit CNG%</label>
              <input
                type="number"
                className="input-imd"
                value={BiFuelKitCNG}
                onChange={(e) => setBiFuelKitCNG(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Loss of Income</label>
              <input
                type="number"
                className="input-imd"
                value={LossOfIncome}
                onChange={(e) => setLossOfIncome(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Emerg. Trans. & Hotel Exp.</label>
              <input
                type="number"
                className="input-imd"
                value={EmergTransHotelExp}
                onChange={(e) =>
                  setEmergTransHotelExp(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>NCB %</label>
              <input
                type="number"
                className="input-imd"
                value={NCB}
                onChange={(e) => setNCB(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Insurance %</label>
              <input
                type="number"
                className="input-imd"
                value={Insurance}
                onChange={(e) => setInsurance(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>IDV %</label>
              <input
                type="number"
                className="input-imd"
                value={IDV}
                onChange={(e) => setIDV(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Road Side Assistance</label>
              <input
                type="number"
                className="input-imd"
                value={RoadSideAssistance}
                onChange={(e) =>
                  setRoadSideAssistance(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Third Party Liability</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyLiability}
                onChange={(e) =>
                  setThirdPartyLiability(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Third Party For Bi-Fuel Kit</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyForBiFuelKit}
                onChange={(e) =>
                  setThirdPartyForBiFuelKit(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Third Party Geographical EX</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyGeographicalEX}
                onChange={(e) =>
                  setThirdPartyGeographicalEX(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>PA Cover</label>
              <input
                type="number"
                className="input-imd"
                value={PACover}
                onChange={(e) => setPACover(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>PA Cover Unnamed Passengers%</label>
              <input
                type="number"
                className="input-imd"
                value={PACoverUnnamedPassenper}
                onChange={(e) =>
                  setPACoverUnnamedPassenper(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>Paid Driver</label>
              <input
                type="number"
                className="input-imd"
                value={PaidDriver}
                onChange={(e) => setPaidDriver(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Legal Liability For Paid Driver</label>
              <input
                type="number"
                className="input-imd"
                value={LegalLiabilityPaidDriver}
                onChange={(e) =>
                  setLegalLiabilityPaidDriver(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>GST%</label>
              <Select
                classNamePrefix="rs"
                options={GSTPercentageList}
                value={
                  GSTPercentageList.find((o) => o.value === GSTPercentage) ||
                  null
                }
                onChange={(selected) => setGSTPercentage(selected?.value || "")}
                styles={customStyles}
                placeholder="Select GST"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>Third Party For One Year</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyForOneYear}
                onChange={(e) =>
                  setThirdPartyForOneYear(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Third Party For Two Year</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyForTwoYear}
                onChange={(e) =>
                  setThirdPartyForTwoYear(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Third Party For Three Year</label>
              <input
                type="number"
                className="input-imd"
                value={ThirdPartyForThreeYear}
                onChange={(e) =>
                  setThirdPartyForThreeYear(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>OD% for 1 Year</label>
              <input
                type="number"
                className="input-imd"
                value={ODpercentagefor1Year}
                onChange={(e) =>
                  setODpercentagefor1Year(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>OD% for 2 Year</label>
              <input
                type="number"
                className="input-imd"
                value={ODpercentagefor2Year}
                onChange={(e) =>
                  setODpercentagefor2Year(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>OD% for 3 Year</label>
              <input
                type="number"
                className="input-imd"
                value={ODpercentagefor3Year}
                onChange={(e) =>
                  setODpercentagefor3Year(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Battery Protection</label>
              <input
                type="number"
                className="input-imd"
                value={BatteryProtection}
                onChange={(e) =>
                  setBatteryProtection(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Charger Protection</label>
              <input
                type="number"
                className="input-imd"
                value={ChargerProtection}
                onChange={(e) =>
                  setChargerProtection(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Daily Allowance</label>
              <input
                type="number"
                className="input-imd"
                value={DailyAllowance}
                onChange={(e) =>
                  setDailyAllowance(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Consumables</label>
              <input
                type="number"
                className="input-imd"
                value={Consumables}
                onChange={(e) => setConsumables(allowNumbers(e.target.value))}
              />
            </div>

            <div className="form-item-imd">
              <label>Nil Depreciation</label>
              <input
                type="number"
                className="input-imd"
                value={NilDepreciation}
                onChange={(e) =>
                  setNilDepreciation(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Battey Cover</label>
              <input
                type="number"
                className="input-imd"
                value={BatteyCover}
                onChange={(e) => setBatteyCover(allowNumbers(e.target.value))}
              />
            </div>

            <div className="form-item-imd">
              <label>Emi Cover</label>
              <input
                type="number"
                className="input-imd"
                value={EmiCover}
                onChange={(e) => setEmiCover(allowNumbers(e.target.value))}
              />
            </div>

            <div className="form-item-imd">
              <label>Tyre And Allow Cover</label>
              <input
                type="number"
                className="input-imd"
                value={TyreAndAllowCover}
                onChange={(e) =>
                  setTyreAndAllowCover(allowNumbers(e.target.value))
                }
              />
            </div>

            <div className="form-item-imd">
              <label>Towing</label>
              <input
                type="number"
                className="input-imd"
                value={Towing}
                onChange={(e) => setTowing(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>Upload Image</label>
              <input
                type="file"
                className="input-imd"
                onChange={(e) => setImageUpload(e.target.files[0])}
              />

              {/* ✅ Upload Button For Image */}
              <button
                type="button"
                className="btn-upload"
                onClick={async () => {
                  const path = await uploadFile(imageUpload);
                  setFilePath1(path); // ← sp_81_34
                  alert("Image Uploaded Successfully");
                }}
              >
                Upload Image
              </button>
            </div>

            <div className="form-item-imd">
              <label>Upload Insurance PDF</label>
              <input
                type="file"
                className="input-imd"
                onChange={(e) => setInsuranceDocumentpdf(e.target.files[0])}
              />

              {/* ✅ Upload Button For PDF */}
              <button
                type="button"
                className="btn-upload"
                onClick={async () => {
                  const path = await uploadFile(insuranceDocumentpdf);
                  setFilePath2(path); // ← sp_81_35
                  alert("PDF Uploaded Successfully");
                }}
              >
                Upload PDF
              </button>
            </div>
          </div>

          <div style={buttonContainerStyle}>
            {!isViewMode && !isEditMode && (
              <button
                style={buttonStyle("#4caf50")}
                type="button"
                onClick={handleSave}
              >
                Save
              </button>
            )}
            {!isViewMode && isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button
              style={buttonStyle("#ab2025")}
              type="button"
              onClick={handleExit}
            >
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* STYLES */}
      <style>{`
      /* react-select global fix */
.rs__menu-portal {
  z-index: 9999 !important;
}

.page-container-imd {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container-imd {
  width: 100%;
  max-width: 100%; 
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

.header-imd {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 18px;
  background: linear-gradient(90deg, #8B1E3F 0%, #8B1E3F 100%);
  box-shadow: 0 2px 6px rgba(121,103,191,0.12);
}
.form-grid-imd {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}


.form-item-imd {
  display: flex;
  flex-direction: column;
}

.form-item-imd label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.input-imd {
  padding: 10px 12px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #cfcfcf;
  background: #fff;
  transition: box-shadow .18s ease, border-color .18s ease;
}

.input-imd:focus {
  outline: none;
  border-color: #4b79a1;
  box-shadow: 0 0 6px rgba(75,121,161,0.18);
}

.button-row-imd {
  margin-top: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;
  width: 100%;
}

.button-row-imd button {
  min-width: 130px;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
}


.btn {
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.save-btn { background: #4caf50; }
.exit-btn { background: #ab2025; }


@media (max-width: 992px) {
  .form-grid-imd {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .form-grid-imd {
    grid-template-columns: 1fr;
  }
  .button-row-imd {
    gap: 10px;
  }

  .button-row-imd button {
    min-width: 110px;
    padding: 10px 16px;
    font-size: 14px;
  }
}
      `}</style>
    </Layout>
  );
};

export default InsuranceMasterDetailsDesign;
